/* istanbul ignore file */
export default ({ palette, typography, breakpoints }) => ({
  horiz: {
    backgroundGradient: 'linear-gradient(100deg, #1fa2ff 0%, #004d99 100% )',
    backgroundColor: '#004d99',
    fontFamily: `"Roboto Condensed", ${typography.fontFamily}`,
    textColor: palette.text.dark,
    linkColor: palette.colors.lochmara,
    dropdown: {
      backgroundColor: palette.background,
      boxShadow: '0px 0px 6px rgba(0,0,0,0.2)',
      borderColor: palette.form.border
    },
    userLink: {
      fontFamily: typography.fontFamily
    },
    borderBottomWidth: 8,
    usernameHoverColor: '#ade2ff',
    tier0: {
      linkHeight: 52,
      linkColor: palette.text.light,
      linkDividerColor: palette.text.light,
      linkPadding: 16,
      linkHoverBackground: 'rgba(0,51,102,0.5)'
    },
    tier1: {
      linkHeight: 36,
      linkColor: palette.text.dark,
      linkDividerColor: palette.colors.silver,
      linkPadding: 20,
      linkHoverBackground: '#ededed'
    }
  },
  direction: 'to bottom',
  outline: {
    width: 1,
    style: 'solid',
    color: palette.info
  },
  link: {
    fontFamily: `"Roboto Condensed", ${typography.fontFamily}`,
    fontSize: 20,
    fontWeight: 300,
    lineHeight: '54px',
    padding: [0, 20, 0, 17],
    color: palette.text.light,
    background: 'transparent',
    disabledOpacity: 0.6,
    icon: {
      height: 16,
      width: 16
    }
  },
  subLink: {
    fontFamily: typography.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '30px',
    padding: [0, 10, 0, 13],
    hoverColor: palette.primary.veryDark,
    color: palette.text.light,
    icon: {
      height: 12,
      width: 12
    }
  },
  collapsed: {
    gradientStart: '#1fa2ff',
    gradientEnd: '#004d99',
    toggleButtonColor: palette.text.light
  },
  hamburgerButtonColor: palette.text.light,
  panelBeforeBackground: null,
  expanded: {
    gradientStart: '#0079cf',
    gradientEnd: '#003f7b',
    toggleButtonColor: palette.text.light
  },
  breakpoints: {
    dockCollapsedToTop: breakpoints.values.sm
  },
  linkDivided: {
    color: 'rgba(255, 255, 255, 0.2)',
    width: 1,
    style: 'solid'
  },
  collapseDuration: 0.3,
  expandDuration: 0.5,
  transitionMode: 'ease-in-out',
  color: palette.text.light,
  activeHighlightColor: palette.info,
  flyOutBackground: palette.primary.veryDark,
  activeFlyOutBackground: palette.primary.normal,
  contentBackgroundColor: 'transparent',
  header: {
    color: palette.text.light,
    borderBottom: {
      style: 'solid',
      width: 1,
      color: 'rgba(255, 255, 255, 0.3)'
    },
    height: 90,
    background: 'transparent',
    padding: [25, 0]
  },
  iconLink: {
    fontSize: 18
  },
  userLink: {
    subTextFontSize: 11,
    subTextMargin: 0,
    padding: [17, 0]
  }
});
